import {
  Box,
  Paper,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAppSelector } from "../../store/store";
import { useEffect, useState } from "react";
import { CircleSVG } from "./Svg";
import FacilityDropdown from "./facilityDropdown";
import { blackClr, whiteClr } from "../../helper/service";
import classnames from "classnames";
import CustomTooltip from "./tooltip";
import CommonAccordion from "./commonAccordian";

const severityLevels = [
  {
    color: "#000000",
    index: 5,
    order: 5,
  },
  {
    color: "#871014",
    index: 4,
    order: 4,
  },
  {
    color: "#FFEF5C",
    index: 3,
    order: 3,
  },
  {
    color: "#FFEF5C",
    index: 2,
    order: 2,
  },
  {
    color: "#98E565",
    index: 1,
    order: 1,
  },
];

export const colorIndexData: any = {
  5: "#000000",
  4: "#871014",
  3: "#FFEF5C",
  2: "#FFEF5C",
  1: "#98E565",
  0: "#FFFFFF",
};

export default function ListViewAccordian(props: any) {
  const {
    heirchyData,
    currentFacilityData,
    setCurrentFacilityData,
    setBallsData,
    handleOverView,
    ballsData,
    roomDeviceCountData,
    goToSummaryPage,
    facilityLevelBallsData,
    setFacilityLevelBallsData,
    floorDeviceCount,
    facilityDeviceCount,
    floorBallClickData,
    ballsDeviceData,
    facilityOption,
    setFacilityOption,
    selectedValueFacility,
    setSelectedValueFacility,
    handleChangeFacility,
    handleOverviewBreadCrumb,
    unitDeviceCount,
    dashboardInterval,
  } = props;
  const { themeMode } = useAppSelector((state) => state.themeSlice);
  // const [selectedValueFacility, setSelectedValueFacility] = useState(10);
  // const [facilityOption, setFacilityOption] = useState<any>([]);

  useEffect(() => {
    if (heirchyData) {
      const filteredFacilities = heirchyData?.filter((item: any) =>
        ["F", "FU"].includes(item.type)
      );
      setFacilityOption(filteredFacilities);
      if (currentFacilityData?.key) {
        const denotedFacility: any = [...filteredFacilities]?.find(
          (x: any) => x?.key === currentFacilityData?.key
        );
        if (denotedFacility) {
          setSelectedValueFacility(denotedFacility?.key);
          setCurrentFacilityData(denotedFacility);
        }
      } else {
        setSelectedValueFacility(filteredFacilities?.[0]?.key);
        setCurrentFacilityData(filteredFacilities[0]);
      }
    }
  }, [heirchyData]);

  function groupBy(array: any, key: any) {
    return array?.reduce((result: any, obj: any) => {
      (result[obj[key]] = result[obj[key]] || []).push(obj);
      return result;
    }, {});
  }

  useEffect(() => {
    const facilityLevelKeys = Object.keys(ballsData);
    if (ballsData && facilityLevelKeys?.length) {
      // Facility Level Data
      const mappedReadingsForFacilityLevel = Object.values(ballsData)?.flatMap(
        (item: any) => item?.readings || []
      );

      if (mappedReadingsForFacilityLevel.length) {
        const groupedByCategory = groupBy(
          mappedReadingsForFacilityLevel,
          "index"
        );

        const finalMappedLevelData: any = severityLevels.map((item: any) => {
          return {
            ...item,
            data_count: groupedByCategory?.[item.index]?.length || 0,
          };
        });

        const floorLevelMappedData: any = {};
        facilityLevelKeys.map((key: any) => {
          const groupedByCategory = groupBy(
            ballsData?.[key]?.readings,
            "index"
          );
          const mainData: any = severityLevels.map((item: any) => {
            return {
              ...item,
              data_count: groupedByCategory?.[item.index]?.length || 0,
            };
          });
          floorLevelMappedData[key] = mainData;
          return true;
        });

        setFacilityLevelBallsData({
          facilityData: finalMappedLevelData,
          floorData: floorLevelMappedData,
        });
      } else {
        setFacilityLevelBallsData({
          facilityData: [],
          floorData: {},
        });
      }
    } else {
      setFacilityLevelBallsData({
        facilityData: [],
        floorData: {},
      });
    }
  }, [ballsData]);

  const [accordianValue, setAccordianValue] = useState<any>([]);
  const [isOpened, setIsOpened] = useState<any>(false);

  return (
    <>
      <CommonAccordion
        sections={
          currentFacilityData?.children?.filter((x: any) => !x?.is_unit) || []
        }
        props={props}
        isUnit={false}
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        accordianValue={accordianValue}
        setAccordianValue={setAccordianValue}
      />
      <CommonAccordion
        sections={
          currentFacilityData?.children?.filter((x: any) => x?.is_unit) || []
        }
        props={props}
        isUnit
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        accordianValue={accordianValue}
        setAccordianValue={setAccordianValue}
      />
    </>
  );
}
